// dhivehiKeyMap.ts
export const DHIVEHI_KEY_MAP: Record<string, string> = {
  // ---- VOWEL MARKS ----
  q: "ް", // sukun
  a: "ަ",
  i: "ި",
  u: "ު",
  e: "ެ",
  o: "ޮ",

  A: "ާ",
  I: "ީ",
  U: "ޫ",
  E: "ޭ",
  O: "ޯ",

  // ---- CONSONANTS ----
  w: "އ",
  r: "ރ",
  t: "ތ",
  y: "ޔ",
  p: "ޕ",

  s: "ސ",
  d: "ދ",
  f: "ފ",
  g: "ގ",
  h: "ހ",
  j: "ޖ",
  k: "ކ",
  l: "ލ",

  z: "ޒ",
  x: "×", // common usage
  c: "ޗ",
  v: "ވ",
  b: "ބ",
  n: "ނ",
  m: "މ",

  // ---- CAPITAL CONSONANTS (SHIFT) ----
  W: "ޢ",
  R: "ޜ",
  T: "ޓ",
  Y: "ޠ",
  P: "ޞ",

  S: "ށ",
  D: "ޑ",
  F: "ﷲ",
  G: "ޣ",
  H: "ޙ",
  J: "ޛ",
  K: "ޚ",
  L: "ޅ",

  Z: "ޡ",
  C: "ޘ",
  V: "ޥ",
  B: "ޝ",
  N: "ޟ",
  M: "ޤ",

  // ---- NUMBERS ----
  "0": "٠",
  "1": "١",
  "2": "٢",
  "3": "٣",
  "4": "٤",
  "5": "٥",
  "6": "٦",
  "7": "٧",
  "8": "٨",
  "9": "٩",

  // ---- PUNCTUATION ----
  ",": "،",
  ".": "۔",
  "?": "؟",
  "/": "؟",
  ";": "؛",
  ":": "፡",
};